const rdcStrings = {
  headerTitle: 'Mobile check deposit',
  disclosure: {
    title: 'Mobile check deposit',
    webTitle: 'Download the Varo app to deposit a check',
    webContent: 'Mobile check deposit is only available in the Varo app.',
    bullets: {
      one: 'Deposit your check',
      two: 'We’ll review your check and get back to you by the end of the next business day.',
      three: {
        a: 'It may take up to 5 business days before funds become available. See the ',
        b: 'Funds Availability Notice and Mobile Check Deposit terms',
        c: ' for more info.',
      },
    },
    buttons: {
      close: 'Close',
      depositCheck: 'Deposit check',
      faq: 'FAQ',
      getApp: 'Get the Varo app',
    },
    errors: {
      activateCard: {
        primaryButton: 'Activate card',
      },
      setupDirectDeposit: {
        primaryButton: 'Setup direct deposit',
      },
    },
  },

  checkDetails: {
    title: 'Check details',
    labels: {
      status: 'Status',
      submittedOn: 'Submitted on',
      confirmationNumber: 'Confirmation number',
      depositTo: 'Deposited to',
      availabilitySchedule: 'Availability schedule',
    },
    agreementText: 'Funds are made available to you per your ',
  },

  reviewDeposit: {
    title: 'Mobile check deposit',
    checkPreview: {
      editButton: 'Retake',
    },
    accountSection: {
      headerTitle: 'Review the info below and make sure it’s correct.',
      amountListItemTitle: 'Check amount',
      accountListItemTitle: 'Account',
    },
    checkImagesSection: {
      headerTitle: 'Check images',
    },
    footerSection: {
      alert: {
        body: 'Once your check is accepted, it may take up to 5 business days for your funds to become available.',
      },
      buttons: {
        depositCheck: 'Deposit check',
        cancel: 'Cancel',
      },
    },
  },

  backOfCheckPhoto: {
    title: 'Let’s take a photo of the back of your check.',
    checklist: {
      title: 'First, make sure the following is written clearly on your check:',
      instructions: {
        lineOne: 'Line 1: Your signature',
        lineTwo: 'Line 2: For Mobile Deposit',
        lineThree: 'Line 3: At Varo Bank Only',
      },
    },
    warningAlertTitle:
      'You must clearly write “For Mobile Deposit” and “At Varo Bank Only” under your signature or your check will be declined.',
    buttons: {
      primaryButton: 'Take photo of back',
      secondaryButton: 'Cancel',
    },
  },

  captureFrontPrompt: {
    title: 'Let’s take a photo of the front of your check',
    subTitle: 'Varo can only accept your check if it’s:',
    bullets: {
      one: 'In your name',
      two: 'Dated within the last 6 months.',
    },
    buttons: {
      takePhoto: 'Take photo of front',
      cancel: 'Cancel',
    },
  },

  outcome: {
    success: {
      title: 'Your ${{amount}} check is in review',
      eyebrowText: 'CHECK SENT',
      confirmationNumber: 'Confirmation {{confirmationNumber}}',
      bullets: {
        one: "We'll review your check and get back to you by the end of the next business day.",
        two: {
          a: 'It may take up to 5 business days before funds become available. See the ',
          b: 'Funds Availability Notice',
          c: ' and ',
          d: 'Mobile Check Deposit terms',
          e: ' for more info.',
        },
      },
      buttons: {
        done: 'Done',
        depositAnother: 'Deposit another check',
      },
    },
    fixable: {
      title: 'Check deposit issues',
      buttons: {
        updateCheckDetails: 'Update check details',
        cancel: 'Cancel',
      },
    },
    confirmable: {
      title: 'We detected a potential error',
      buttons: {
        reviewCheck: 'Review check',
        sendCheckAsIs: 'Send check as is',
      },
    },
    rejected: {
      title: 'Check not accepted',
      message: 'We sent you an email with more information.',
      buttons: {
        done: 'Done',
      },
    },
    error: {
      buttons: {
        retry: 'Retry',
        cancel: 'Cancel',
      },
    },
  },

  checkHistoryTable: {
    defaultCheckTitle: 'Mobile Check Deposit',
    confirmation: 'Confirmation',
    pendingSectionTitle: 'Pending',
  },

  accountSelection: {
    headerTitle: 'Mobile check deposit',
    selectAnAccount: 'Select an account',
    buttonLabel: 'Next',
    labelTextTo: 'To:',
    transferLimit: 'Your limit for this transfer is ',
  },

  accountSelectionDrawer: {
    description: 'Which account would you like to deposit your check to?',
  },

  rdcHistoryEmptyState: {
    title: 'Mobile deposit history',
    noHistoryTitle: 'You haven’t initiated any transfer yet',
    noHistoryMessage:
      'Deposit a check and we’ll review it and get back to you by the end of the next business day.',
    buttonLabel: 'Deposit a check',
  },

  captiveDialog: {
    title: 'Are you sure you want to cancel?',
    message:
      'If you cancel you will have to restart the process all over again.',
    buttons: {
      cancel: 'Yes, cancel',
      neverMind: 'Nevermind',
    },
  },

  reviewImage: {
    heading: 'Review your document',
    body: 'Your document is legible and all four corners of the document are in the frame',
    buttons: {
      retake: 'Retake',
      usePhoto: 'Use Photo',
    },
  },

  cameraPermissionDisabled: {
    heading: 'To deposit a check, let us access your camera',
    bullets: {
      one: 'You will need to take a photo of the front and back of your check.',
      two: 'Open settings, go to permissions and allow access to camera.',
    },
    buttons: {
      openSettings: 'Open settings',
    },
  },
};

export default rdcStrings;
